// This should come from the database

const menu = (role) => {
  const menuItems = [
    {
      id: 1,
      label: "Candidaturas",
      icon: "UserMultiple16",
      roles: ["200", "201", "202", "203", "204"],
      items: [
        {
          id: 1.1,
          label: "Registar",
          link: "/admin/create-candidature",
          roles: ["201", "202", "203"],
        },
        {
          id: 1.2,
          label: "Consultar",
          link: "/admin/candidatures",
          roles: ["200", "202", "203"],
        },
        {
          id: 1.2,
          label: "Consultar",
          link: "/admin/candidature/redirect",
          roles: ["201"],
        },
        {
          id: 1.3,
          label: "Por Oficial de Inscrição",
          link: "/admin/enrollment-officers",
          roles: ["200", "202"],
        },
        {
          id: 1.4,
          label: "Por Distrito",
          link: "/admin/candidatures-by-district",
          roles: ["200", "202"],
        },
        {
          id: 1.5,
          label: "Pontuar",
          link: "/admin/candidatures-by-jury",
          roles: ["204"],
        },
        {
          id: 1.6,
          label: "Ranking",
          link: "/admin/candidatures-ranking",
          roles: ["200"],
        },
        {
          id: 5.3,
          label: "Pontuação por júri",
          link: "/admin/estatisticas-pontuacao",
          roles: ["200"],
        },
      ],
    },
    {
      id: 2,
      label: "Protótipos",
      icon: "Application24",
      roles: ["200", "201", "204", "205"],
      items: [
        {
          id: 2.1,
          label: "O Meu Protótipo",
          link: "/admin/prototype",
          roles: ["201"],
        },
        {
          id: 2.2,
          label: "Consultar",
          link: "/admin/prototypes",
          roles: ["200", "205"],
        },
        {
          id: 2.3,
          label: "Pontuar",
          link: "/admin/jury-prototypes",
          roles: ["204"],
        },
        {
          id: 2.4,
          label: "Ranking",
          link: "/admin/prototypes-ranking",
          roles: ["200"],
        },
        {
          id: 2.5,
          label: "Pontuação por júri",
          link: "/admin/prototype-jury-stats",
          roles: ["200"],
        },
      ],
    },
    {
      id: 5,
      label: "Utilizadores",
      icon: "UserMultiple16",
      roles: ["200", "201", "202", "203", "204"],
      items: [
        {
          id: 5.1,
          label: "Registar",
          link: "/admin/registar-utilizador",
          roles: ["200"],
        },
        {
          id: 5.2,
          label: "Consultar",
          link: "/admin/utilizadores",
          roles: ["200"],
        },

        {
          id: 5.4,
          label: "Minha conta",
          link: "/admin/minha-conta",
          roles: ["200", "201", "202", "203", "204"],
        },
      ],
    },
  ];

  const userMenu = menuItems.filter((m) => m.roles.includes(role));
  userMenu.forEach((menu) => {
    menu.items = menu.items.filter((mi) => mi.roles.includes(role));
  });

  return userMenu;
};

export default menu;
